import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

export const SET_INTERVENTII = 'SET_INTERVENTII'
export const ADD_INTERVENTIE = 'ADD_INTERVENTIE'
export const SET_PROCEDURI = 'SET_PROCEDURI'
export const EDIT_PROCEDURA = 'EDIT_PROCEDURA'
export const ADD_PROCEDURA = 'ADD_PROCEDURA'
export const DELETE_PROCEDURA = 'DELETE_PROCEDURA'

Vue.use(VueMoment, {
  moment
})

export default {
  [SET_INTERVENTII] (state, payload) {
    state.interventii = []
    Object.values(payload).forEach(function (interventieNode) {
      state.interventii.push({
        id: interventieNode.nid[0].value,
        uid: interventieNode.uid[0].target_id,
        title: interventieNode.title[0].value,
        uidPacient: !(interventieNode.field_pacient_inter == '')
          ? interventieNode.field_pacient_inter[0].target_id
          : '58',
        proceduri: !(interventieNode.field_interventie == '')
          ? interventieNode.field_interventie
          : ''
      })
    })
  },
  [ADD_INTERVENTIE] (state, { title }) {
    state.ainterventie.push({ title })
  },
  [SET_PROCEDURI] (state, payload) {
    state.proceduri = []
    Object.values(payload).forEach(function (proceduraNode) {
      state.proceduri.push({
        id: proceduraNode.id[0].value,
        parentId: proceduraNode.parent_id[0].value,
        data: !(proceduraNode.field_data == '')
          ? proceduraNode.field_data[0].value
          : '',
        desc: !(proceduraNode.field_descriere == '')
          ? proceduraNode.field_descriere[0].value
          : '',
        pret: !(proceduraNode.field_pret == '')
          ? proceduraNode.field_pret[0].value
          : '',
        statusplatit: !(proceduraNode.field_platit == '')
          ? proceduraNode.field_platit[0].value
          : false
      })
    })
  },
  [EDIT_PROCEDURA] (state, { id }) {
    state.eprocedura.push({ id })
  },
  [ADD_PROCEDURA] (state, { id }) {
    state.aprocedura.push({ id })
  },
  [DELETE_PROCEDURA] (state, { id }) {
    state.dprocedura.push({ id })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/interventii/InterventiiMutations.js